// TODO: eslint
/* eslint-disable react/no-find-dom-node */
import ReactDOM from 'react-dom';

const StickyTable = {
  // StickyTable requires a table element with a "stickyTable" ref,
  // and within that table should be "StickyHeaderRow" elements.

  // Also must implement:
  // shouldStickyHeadersUpdate(object prevProps, object prevState)
  // which should return true if the width of the sticky headers may
  // have changed (eg school class data has been loaded or changed)

  getInitialState() {
    return {
      stickyHeaderWidth: null,
      stickyHeaderLeftBoundary: null,
      stickyTableMinWidth: null,
    };
  },

  /*
  handleScroll: function(evt) {
    if (this.isMounted()) {
      var newScrollX = window.scrollX;
      if (newScrollX !== this.prevScrollX) {
        this.prevScrollX = newScrollX;
        this.forceUpdate();
      }
    }
  },
  */

  componentDidMount() {
    // This will happen before first render, and when routed back from eg an ExamGrid
    // window.addEventListener('scroll', this.handleScroll);
    this.updateStickyHeadersIfRequired({}, {});
  },

  componentWillUnmount() {
    // window.removeEventListener('scroll', this.handleScroll);
  },

  componentDidUpdate(prevProps, prevState) {
    this.updateStickyHeadersIfRequired(prevProps, prevState);
  },

  updateStickyHeadersIfRequired(prevProps, prevState) {
    if (
      this.shouldStickyHeadersUpdate &&
      this.shouldStickyHeadersUpdate(prevProps, prevState)
    ) {
      // Resize the table and body to a nice wide width, to give everything
      // a chance to render properly. Add a callback so as soon as that's done,
      // grab the width of the sticky headers and resize the table+body back to
      // what it should be. :-)
      $('body').css('min-width', '10000px');
      this.setState({ stickyTableMinWidth: 10000 }, () => {
        const newStickyHeaderWidth = this.getStickyHeaderWidth();
        const newStickyTableMinWidth =
          this.getStickyTableMinWidth(newStickyHeaderWidth);
        const newState = {
          stickyHeaderWidth: newStickyHeaderWidth,
          stickyHeaderLeftBoundary: this.getStickyHeaderLeftBoundary(),
          stickyTableMinWidth: newStickyTableMinWidth,
        };
        $('body').css(
          'min-width',
          `${newStickyTableMinWidth + this.getStickyHeaderLeftBoundary()}px`
        );
        this.setState(newState);
      });
    }
  },

  getScrollPosition() {
    const $window = $(window);
    const scrollPosition = {
      top: $window.scrollTop(),
      left: $window.scrollLeft(),
    };
    return scrollPosition;
  },

  getStickyHeaderWidth() {
    // Get the width of the longest student name
    // TODO: do react-wise
    const maxWidth = Math.max.apply(
      null,
      $('.fixed')
        .map(function () {
          return $(this).outerWidth(true);
        })
        .get()
    );
    return maxWidth;
  },

  getStickyHeaderLeftBoundary() {
    // See how far away from the left edge of window the sticky elements are
    const leftOffset = ReactDOM.findDOMNode(this.refs.stickyTable).offsetLeft;
    return leftOffset;
  },

  getStickyTableMinWidth(stickyHeaderWidth) {
    const gridWidth =
      stickyHeaderWidth +
      ReactDOM.findDOMNode(this.refs.stickyTable).offsetWidth;
    return gridWidth;
  },
};

export default StickyTable;
